export default "__VITE_ASSET__650425de__"